import { FC, JSX } from 'react'
import { BusinessProfileAvatar, BusinessProfileAvatarType } from './Avatar'
import { Table, TableType } from './Table'

export const BusinessProfile: FC &
  BusinessProfileAvatarType &
  TableType = (): JSX.Element => <></>

BusinessProfile.Avatar = BusinessProfileAvatar
BusinessProfile.Table = Table
